import React, { useState } from 'react';
import User from "../../../models/User";
import UserImageCircle from "../../../components/UserImageCircle";

const ProfileReferenceRow = ({ reference, showContact, ...props }) => {
    const [referenceUser, setReferenceUser] = useState(() => User.make({ ...reference }))
    return (
        <div key={reference.id} className="py-6 gap-6 flex">
            <div className="w-24 shrink-0">
                {/* <img className="w-full" src={certification.image_path} /> */}
                <UserImageCircle user={referenceUser} hideTooltip={true} size={90} />
            </div>

            <div className="w-full">
                <p className="text-lg font-bold">{referenceUser.firstNamePlusInitial()}</p>
                <p className="text-wrippleBlueGray">
                    {reference.job_title} {reference.role && (
                        <span>({reference.role})</span>
                    )}
                </p>
                <div className="flex gap-3">
                    {showContact && (
                        <>
                            {reference.email && (
                                <a href={`mailto:${reference.email}`}>
                                    <i className="fas fa-phone text-base" />
                                </a>
                            )}
                            {reference.phone && (
                                <a href={`tel:${reference.phone}`}>
                                    <i className="fas fa-envelope text-lg" />
                                </a>
                            )}
                        </>
                    )}
                    {reference.linkedin_profile_url && (
                        <a href={reference.linkedin_profile_url}>
                            <i className="fab fa-linkedin text-lg" />
                        </a>
                    )}
                </div>
                {/* <div className="pt-3">
                    <p className="font-bold">Comments from {reference.first_name}</p>
                    <p className="pt-1">{reference.comments ? (
                        <span>
                            {reference.comments}
                        </span>
                    ) : (
                        <i>None Provided</i>
                    )}</p>
                </div> */}
            </div>
        </div>
    )
};

export default ProfileReferenceRow;